import { render } from "./MainBox.vue?vue&type=template&id=ee175d80&scoped=true"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=ee175d80&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee175d80"]])

export default __exports__